if (!customElements.get("silxine-notify-purchase")) {
  customElements.define("silxine-notify-purchase", class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form = this.querySelector('form[action*="/cart/add"]');
      this.quantity = this.form?.querySelector('[name="quantity"]');
      this.quantity?.addEventListener("input", () => this.updateAmounts(), options);
      this.quantity?.addEventListener("change", () => this.updateAmounts(), options);
      this.openButton = this.querySelector("[data-purchase-open]");
      this.openButton?.addEventListener("click", () => this.setExpanded(true), options);
      this.querySelector("[data-purchase-close]")?.addEventListener("click", () => {
        this.setExpanded(false);
        this.openButton?.focus();
      }, options);
      this.form?.addEventListener("formdata", (event) => {
        const data = event.formData;
        if (this.dataset.mode === "preorder") {
          data.set("selling_plan", this.dataset.plan);
          data.set("properties[_Sale type]", data.get("properties[Sale type]") || "Pre-order");
          ["Sale type", "Expected availability", "Payment", "Pre-order gift"].forEach(key => data.delete("properties[" + key + "]"));
        } else if (this.dataset.mode === "stock") {
          data.delete("selling_plan");
          ["_purchase_type", "_selling_plan_id", "_Sale type", "Sale type", "Expected availability", "Payment", "Pre-order gift", "Shipping", "Gift included"].forEach(key => data.delete("properties[" + key + "]"));
        }
      }, options);
      this.form?.addEventListener("submit", (event) => {
        if (this.dataset.mode === "notify") {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.observer = new MutationObserver(() => this.syncAppSchedule());
      if (this.form) this.observer.observe(this.form, { childList: true, subtree: true, characterData: true });
      this.syncAppSchedule();
      this.updateAmounts();
      if ("IntersectionObserver" in window) {
        this.actionVisibilityObserver = new IntersectionObserver(([entry]) => {
          this.dataset.actionsInView = String(entry.isIntersecting);
        });
        this.actionVisibilityObserver.observe(this);
      }
      this.dataset.ready = "true";
      this.setExpanded(this.dataset.expanded === "true");
      this.addEventListener("click", (event) => {
        if (event.target.closest(".restock-alerts-notify-button, [id^=restock-]")) this.watchNotifyModal();
      }, { ...options, capture: true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.actionVisibilityObserver?.disconnect();
      this.notifyWaitObserver?.disconnect();
      this.notifyModalObserver?.disconnect();
      this.notifyController?.abort();
      clearTimeout(this.notifyWaitTimeout);
    }
    setExpanded(expanded) {
      this.dataset.expanded = expanded ? "true" : "false";
      this.openButton?.setAttribute("aria-expanded", String(expanded));
    }
    watchNotifyModal() {
      this.notifyWaitObserver?.disconnect();
      clearTimeout(this.notifyWaitTimeout);
      const attach = () => {
        const modal = [...document.querySelectorAll(".nm-top-layer-dialog[open] .restock-alerts-modal-box")].find(box => box.querySelector(".restock-alerts-variant-select")?.value === this.dataset.variant);
        if (!modal) return;
        this.notifyWaitObserver?.disconnect();
        clearTimeout(this.notifyWaitTimeout);
        this.styleNotifyModal(modal);
      };
      this.notifyWaitObserver = new MutationObserver(attach);
      this.notifyWaitObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["open"] });
      this.notifyWaitTimeout = setTimeout(() => this.notifyWaitObserver?.disconnect(), 10000);
      attach();
    }
    styleNotifyModal(modal) {
      const copy = JSON.parse(this.querySelector("[data-notify-modal-copy]").textContent);
      this.notifyModalObserver?.disconnect();
      this.notifyController?.abort();
      this.notifyController = new AbortController();
      const options = { signal: this.notifyController.signal };
      const dialog = modal.closest("dialog");
      modal.dataset.silxineNotify = "true";
      modal.dataset.silxineOriginalSubmit ||= modal.querySelector(".restock-alerts-submit-button")?.textContent.trim();
      const originalSubmit = modal.dataset.silxineOriginalSubmit;
      const setText = (selector, text) => {
        const node = modal.querySelector(selector);
        if (!node || node.textContent === text) return;
        const textNodes = [...node.childNodes].filter(child => child.nodeType === Node.TEXT_NODE);
        textNodes.forEach((child, index) => {
          const value = index === 0 ? text : "";
          if (child.data !== value) child.data = value;
        });
      };
      const decorate = () => {
        const email = modal.querySelector(".restock-alerts-email-input");
        if (!email) return;
        setText(".restock-alerts-form-title", copy.title);
        setText(".restock-alerts-email-label-span", copy.email);
        setText(".restock-alerts-sms-label-span", copy.mobile);
        const title = modal.querySelector(".restock-alerts-form-title");
        if (!modal.querySelector(".silxine-notify__intro")) {
          const intro = document.createElement("p");
          intro.className = "silxine-notify__intro";
          intro.textContent = copy.intro;
          title.after(intro);
        }
        title.id = "Silxine-Notify-Title";
        dialog.setAttribute("aria-labelledby", title.id);
        email.type = "email";
        email.required = true;
        email.autocomplete = "email";
        email.placeholder = copy.emailPlaceholder;
        email.id = "Silxine-Notify-Email";
        modal.querySelector(".restock-alerts-email-label")?.setAttribute("for", email.id);
        const mobile = modal.querySelector(".restock-alerts-sms-input");
        if (mobile) {
          mobile.type = "tel";
          mobile.autocomplete = "tel-national";
          mobile.placeholder = copy.mobilePlaceholder;
          mobile.id = "Silxine-Notify-Mobile";
          modal.querySelector(".restock-alerts-sms-label")?.setAttribute("for", mobile.id);
        }
        modal.querySelector(".restock-alerts-country-select")?.setAttribute("aria-label", copy.country);
        const variant = modal.querySelector(".restock-alerts-variant-select");
        if (variant && !modal.querySelector(".silxine-notify__variant-label")) {
          variant.id = "Silxine-Notify-Variant";
          const label = document.createElement("label");
          label.className = "silxine-notify__variant-label";
          label.htmlFor = variant.id;
          label.textContent = copy.variant;
          variant.before(label);
        }
        const submit = modal.querySelector(".restock-alerts-submit-button");
        if (submit && !submit.disabled && !submit.childElementCount && submit.textContent.includes(originalSubmit)) setText(".restock-alerts-submit-button", copy.submit);
        const close = modal.querySelector(".modal-close-btn");
        close?.setAttribute("role", "button");
        close?.setAttribute("tabindex", "0");
        close?.setAttribute("aria-label", copy.close);
      };
      decorate();
      modal.addEventListener("click", (event) => {
        if (!event.target.closest(".restock-alerts-submit-button")) return;
        const email = modal.querySelector(".restock-alerts-email-input");
        if (email && !email.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          email.reportValidity();
        }
      }, { ...options, capture: true });
      modal.addEventListener("keydown", (event) => {
        const close = event.target.closest(".modal-close-btn");
        if (close && ["Enter", " "].includes(event.key)) {
          event.preventDefault();
          close.dispatchEvent(new MouseEvent("click", { bubbles: true }));
        }
      }, options);
      dialog.addEventListener("close", () => {
        this.notifyModalObserver?.disconnect();
        this.notifyController?.abort();
        this.querySelector(".restock-alerts-notify-button")?.focus();
      }, options);
      this.notifyModalObserver = new MutationObserver(decorate);
      this.notifyModalObserver.observe(modal, { childList: true, subtree: true, characterData: true });
    }
    updateAmounts() {
      if (this.dataset.mode !== "preorder") return;
      const quantity = Number(this.quantity?.value || 1);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: this.dataset.currency,
      });
      this.querySelectorAll("[data-unit-amount]").forEach(element => {
        const amount = Number(element.dataset.unitAmount);
        if (Number.isFinite(amount)) element.textContent = formatter.format(amount * quantity / 100);
      });
    }
    syncAppSchedule() {
      if (this.dataset.mode !== "preorder") return;
      const idle = this.querySelector("[data-add-to-cart-idle]");
      if (this.dataset.submitLabel && idle?.textContent.trim() === "Pre-order now") {
        idle.textContent = this.dataset.submitLabel;
      }
      const source = this.querySelector(".hengam-preorder-selling-plan-selector");
      const date = source?.textContent.match(/Due later on (\d{4}-\d{2}-\d{2})/);
      const target = this.querySelector("[data-plan-schedule]");
      const displayDate = date ? new Intl.DateTimeFormat(document.documentElement.lang || "en", {
        month: "short", day: "numeric", year: "numeric", timeZone: "UTC"
      }).format(new Date(date[1] + "T00:00:00Z")) : null;
      const schedule = displayDate ? this.dataset.scheduleLabel.replace("__DATE__", displayDate) : this.dataset.fallbackSchedule;
      if (target && target.textContent !== schedule) target.textContent = schedule;
    }
  });
}
